import { useEffect, useRef } from 'react';

/** Refresh eligible answers when the current session's agent becomes idle. */
export function useRefreshChatFeedbackOnIdle(
  sessionId: string | null,
  agentActive: boolean,
  refresh: () => void,
): void {
  const previous = useRef({ sessionId, agentActive });

  useEffect(() => {
    const finished =
      sessionId !== null && previous.current.sessionId === sessionId && previous.current.agentActive && !agentActive;
    previous.current = { sessionId, agentActive };
    if (finished) refresh();
  }, [sessionId, agentActive, refresh]);
}
